"use client";
import { j as r } from "./jsx-runtime-CJ-St4mQ.mjs";
import { useState as u } from "react";
import h from "./Select.js";
import { O as m } from "./Option-Omg-vJyi.mjs";
const Y = ({ onChange: d }) => {
  const a = /* @__PURE__ */ new Date(), o = a.getMonth() + 1, n = a.getFullYear(), [s, i] = u(o), [c, g] = u(n), p = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ], f = Array.from({ length: 6 }, (e, t) => n + t), l = (e, t) => {
    const y = `${e}-${String(t).padStart(2, "0")}`;
    d(y);
  }, x = (e) => {
    i(e), l(c, e);
  }, j = (e) => {
    g(e), l(e, s);
  };
  return /* @__PURE__ */ r.jsxs("div", { className: "grid grid-cols-2 gap-3", children: [
    /* @__PURE__ */ r.jsx(
      h,
      {
        value: s,
        defaultValue: o,
        onChange: x,
        children: p.map((e, t) => /* @__PURE__ */ r.jsx(m, { value: t + 1, children: e }, e))
      }
    ),
    /* @__PURE__ */ r.jsx(
      h,
      {
        defaultValue: n,
        value: c,
        onChange: j,
        children: f.map((e) => /* @__PURE__ */ r.jsx(m, { value: e, children: e }, e))
      }
    )
  ] });
};
export {
  Y as default
};
